(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7512],{

/***/ 3198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 9615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CompanyList; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Chips-2709174d.mjs
var Chips_2709174d = __webpack_require__(7759);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-3122c134.mjs
var Icon_3122c134 = __webpack_require__(3355);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/CompanyList.js






const H = "company-card", x = "desktop", T = "company-card__header", b = "company-card__header__title", O = "company-card__header__logo", w = "company-card__divider", D = "company-card__services", I = "company-card__services__item", P = "company-card__services__show_button", B = "company-card__services__overlay", R = "company-card__description", W = "company-card__link", A = "company-card__skeleton", U = "skeleton", z = "company-card__skeleton__title", G = "company-card__skeleton__paragraph", M = "company-card__skeleton__link", a = {
  companyCard: H,
  desktop: x,
  companyCardHeader: T,
  companyCardHeaderTitle: b,
  companyCardHeaderLogo: O,
  companyCardDivider: w,
  companyCardServices: D,
  companyCardServicesItem: I,
  companyCardServicesShowButton: P,
  companyCardServicesOverlay: B,
  companyCardDescription: R,
  companyCardLink: W,
  companyCardSkeleton: A,
  skeleton: U,
  companyCardSkeletonTitle: z,
  companyCardSkeletonParagraph: G,
  companyCardSkeletonLink: M
};
function V(n) {
  return n.isLoading ? /* @__PURE__ */ react.createElement(j, null) : /* @__PURE__ */ react.createElement(q, { ...n });
}
function j() {
  return /* @__PURE__ */ react.createElement(
    "article",
    {
      "data-testid": "company-card",
      className: a.companyCard,
      role: "none"
    },
    /* @__PURE__ */ react.createElement("header", { className: a.companyCardHeader }, /* @__PURE__ */ react.createElement("div", { className: a.companyCardSkeletonTitle }), /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(
          a.companyCardHeaderLogo,
          a.companyCardSkeleton
        )
      }
    )),
    /* @__PURE__ */ react.createElement("div", { className: a.companyCardDivider }),
    /* @__PURE__ */ react.createElement("div", { className: a.companyCardSkeletonParagraph }, Array(4).fill(null).map((n, r) => /* @__PURE__ */ react.createElement("div", { key: r }))),
    /* @__PURE__ */ react.createElement("div", { className: a.companyCardSkeletonParagraph }, Array(9).fill(null).map((n, r) => /* @__PURE__ */ react.createElement("div", { key: r }))),
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (a.companyCardLink, a.companyCardSkeletonLink)
      }
    )
  );
}
function q(n) {
  const {
    name: r,
    imageUrl: d,
    services: t = [],
    description: p,
    linkUrl: c,
    i18n: y = {}
  } = n, {
    goToCompanySiteLabel: S = "Go to company site",
    showLessLabel: u = "Show less",
    showMoreLabel: h = "Show more"
  } = y, C = t.length > 4, [o, N] = (0,react.useState)(!1), g = () => N((m) => !m), L = (0,react.useMemo)(() => o ? t : t.slice(0, 4), [t, o]);
  return /* @__PURE__ */ react.createElement("article", { "data-testid": "company-card", className: a.companyCard }, /* @__PURE__ */ react.createElement("header", { className: a.companyCardHeader }, /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: c,
      disableLinkTextStyle: !0,
      className: (0,app_a75c1d35.c)(
        a.companyCardHeaderTitle,
        app_a75c1d35.t.textsLeadTextBold
      ),
      target: "_blank"
    },
    r
  ), d ? /* @__PURE__ */ react.createElement(
    "img",
    {
      src: d,
      alt: "",
      "aria-hidden": "true",
      className: a.companyCardHeaderLogo,
      loading: "lazy",
      onError: (m) => m.currentTarget.hidden = !0
    }
  ) : null), /* @__PURE__ */ react.createElement("div", { className: a.companyCardDivider }), t.length > 0 ? /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("ul", { className: a.companyCardServices }, L.map((m) => /* @__PURE__ */ react.createElement(
    "li",
    {
      key: m,
      className: (0,app_a75c1d35.c)(
        a.companyCardServicesItem,
        app_a75c1d35.t.textsCaption
      ),
      "data-clip": C && !o
    },
    m
  )), C && /* @__PURE__ */ react.createElement(
    "div",
    {
      role: "none",
      className: a.companyCardServicesOverlay,
      hidden: o
    }
  )), C && /* @__PURE__ */ react.createElement(
    "button",
    {
      onClick: g,
      className: (0,app_a75c1d35.c)(
        a.companyCardServicesShowButton,
        app_a75c1d35.t.textsCaption
      )
    },
    o ? u : h,
    /* @__PURE__ */ react.createElement(
      Icon_3122c134.I,
      {
        icon: o ? Icon_3122c134.W.CHEVRON_UP : Icon_3122c134.W.CHEVRON_DOWN,
        size: 16
      }
    )
  )) : null, /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(
        a.companyCardDescription,
        app_a75c1d35.t.textsBodyText
      )
    },
    p
  ), /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      href: c,
      disableLinkTextStyle: !0,
      className: (0,app_a75c1d35.c)(a.companyCardLink),
      target: "_blank"
    },
    S,
    /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.ARROW_UP_RIGHT, size: 16 })
  ));
}
function $({
  companyCards: n,
  skeletonLoadingCount: r = 3,
  topPadding: d = Block_9b78bd10.B.Padding.NONE,
  bottomPadding: t = Block_9b78bd10.B.Padding.NONE
}) {
  const p = (0,react.useMemo)(
    () => n ?? F(r),
    [n, r]
  );
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      "data-testid": "company-cards",
      topPadding: d,
      bottomPadding: t
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, null, p.map((c, y) => /* @__PURE__ */ react.createElement(V, { key: "name" in c ? c.name : y, ...c })))
  );
}
function F(n) {
  return Array(n).fill({ isLoading: !0 });
}

//# sourceMappingURL=CompanyList.js.map

// EXTERNAL MODULE: ../wif-ui-lib/dist/Pagination.js
var Pagination = __webpack_require__(3403);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/constants/durations.ts
var durations = __webpack_require__(4780);
// EXTERNAL MODULE: ./src/hooks/useQuery.ts + 1 modules
var useQuery = __webpack_require__(808);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyList/useCompaniesQuery.ts





function useCompaniesQuery(service) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6, initCompanyResults = arguments.length > 3 ? arguments[3] : void 0;
    var ref = (0,router.useRouter)(), locale = ref.locale, isPreview = ref.isPreview;
    var transformer = useTransformWifCompanyToCompanyCardProps();
    var offset = (page - 1) * limit;
    var searchParams = new URLSearchParams();
    searchParams.append("offset", offset.toString());
    searchParams.append("limit", limit.toString());
    service && searchParams.append("service", service);
    locale && searchParams.append("lang", locale);
    var ref1 = (0,useQuery/* default */.Z)("/api/companies/?".concat(searchParams.toString()), {
        cacheDurationInMs: isPreview ? 0 : durations/* ONE_MIN_IN_MS */.sW * 10,
        initialData: initCompanyResults
    }), data = ref1.data, isLoading = ref1.isLoading;
    var totalCount = (data === null || data === void 0 ? void 0 : data.total) || 0;
    var pageCount = Math.ceil(totalCount / limit);
    var companyCards = (0,react.useMemo)(function() {
        return isLoading ? undefined : data === null || data === void 0 ? void 0 : data.results.map(transformer);
    }, [
        data === null || data === void 0 ? void 0 : data.results,
        isLoading,
        transformer
    ]);
    return {
        companyCards: companyCards,
        totalCount: totalCount,
        pageCount: pageCount
    };
}
function useTransformWifCompanyToCompanyCardProps() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return (0,react.useCallback)(function(company) {
        return {
            name: company.name,
            description: company.description || "",
            linkUrl: company.website || "",
            imageUrl: company.logoUrl,
            services: company.services.map(function(service) {
                var ref;
                return ((ref = service.label) === null || ref === void 0 ? void 0 : ref.toString()) || service.value;
            }),
            i18n: {
                goToCompanySiteLabel: t("company.goToCompanySite"),
                showLessLabel: t("company.showLess"),
                showMoreLabel: t("company.showMore")
            }
        };
    }, [
        t
    ]);
}

// EXTERNAL MODULE: ./src/magnolia/components/CompanyList/CompanyList.module.scss
var CompanyList_module = __webpack_require__(6908);
var CompanyList_module_default = /*#__PURE__*/__webpack_require__.n(CompanyList_module);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyList/CompanyList.tsx










var companyListId = "company_list";
var smallPadding = Block_9b78bd10.B.Padding.SMALL;
var noPadding = Block_9b78bd10.B.Padding.NONE;
function CompanyList(param) {
    var _title = param.title, title = _title === void 0 ? "Service Partners" : _title, _categoryTitle = param.categoryTitle, categoryTitle = _categoryTitle === void 0 ? "Type of services" : _categoryTitle, _services = param.services, services = _services === void 0 ? [] : _services, initCompanyResults = param.initCompanyResults;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useRef)(null);
    var limit = useLimit();
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(undefined), selectedService = ref2[0], setSelectedService = ref2[1];
    var ref3 = useCompaniesQuery(selectedService, page, limit, initCompanyResults !== null && initCompanyResults !== void 0 ? initCompanyResults : undefined), pageCount = ref3.pageCount, totalCount = ref3.totalCount, companyCards = ref3.companyCards;
    var toggleSelectedService = (0,react.useCallback)(function(serviceValue) {
        setSelectedService(function(current) {
            return current === serviceValue ? undefined : serviceValue;
        });
    }, []);
    var handlePageChange = (0,react.useCallback)(function(page) {
        setPage(page);
        if (true) {
            var ref1;
            var top = ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.offsetTop) || 0;
            window.scrollTo(0, top - 80);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: companyListId,
        className: getStyleClassName(),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCategories, {
                title: categoryTitle,
                services: services,
                selectedService: selectedService,
                toggleSelectedService: toggleSelectedService
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B, {
                topPadding: smallPadding,
                bottomPadding: noPadding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B.Content, {
                    flex: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: getStyleClassName("header") + " heading__section",
                        children: [
                            totalCount,
                            " ",
                            title
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)($, {
                topPadding: smallPadding,
                bottomPadding: smallPadding,
                skeletonLoadingCount: limit,
                companyCards: companyCards
            }),
            pageCount > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                count: pageCount,
                value: page,
                onChange: handlePageChange,
                i18n: {
                    btnNextText: t("pagination.nextPage"),
                    btnPageText: t("pagination.goToPage"),
                    btnPrevText: t("pagination.previousPage")
                }
            }) : null
        ]
    });
}
function useLimit() {
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    if (viewport === "xs" || viewport === "sm") return 4;
    if (viewport === "md" || viewport === "lg") return 6;
    return 9;
}
function CompanyCategories(param) {
    var services = param.services, title = param.title, toggleSelectedService = param.toggleSelectedService, selectedService = param.selectedService;
    if (!Array.isArray(services) || services.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_9b78bd10.B, {
        as: "header",
        topPadding: smallPadding,
        bottomPadding: noPadding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block_9b78bd10.B.Content, {
            flex: true,
            className: getStyleClassName("categories"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "texts__component_title--bold",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: getStyleClassName("categories", "chips"),
                    children: services.map(function(service) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Chips_2709174d.C, {
                            as: "button",
                            text: ((ref = service.label) === null || ref === void 0 ? void 0 : ref.toString()) || service.value,
                            onClick: function() {
                                return toggleSelectedService(service.value);
                            },
                            selected: selectedService === service.value,
                            clipLongText: false
                        }, service.value);
                    })
                })
            ]
        })
    });
}
function getStyleClassName() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return (CompanyList_module_default())[[
        companyListId
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).join("__")];
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyList/index.ts



/***/ }),

/***/ 6908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_list":"CompanyList_company_list__yY3AT","company_list__categories":"CompanyList_company_list__categories__or_tc","company_list__categories__chips":"CompanyList_company_list__categories__chips__xaghf","company_list__header":"CompanyList_company_list__header__FAdge"};

/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ G; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7977);






const w = "pagination", N = "pagination__items", S = "pagination__item", L = "pagination__item--selected", k = "pagination__caption", d = {
  pagination: w,
  paginationItems: N,
  paginationItem: S,
  paginationItemSelected: L,
  paginationCaption: k
};
function A(n) {
  const { value: t = 1, count: e, onChange: o } = n, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [i, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(P(t, e)), [, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useTransition)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => m(P(t, e)), [t, e]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      const r = typeof l == "number" ? l : l(i), g = P(r, e);
      g !== i && (m(g), o && p(() => o(g)));
    },
    [i, o, e]
  ), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      switch (l.key) {
        case "ArrowRight":
          return a.current?.focus(), c((r) => r + 1);
        case "ArrowLeft":
          return a.current?.focus(), c((r) => r - 1);
      }
    },
    [c]
  ), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => D(i, e), [i, e]);
  return { page: i, handlePageChange: c, itemList: b, handleKeyDown: f, containerRef: a };
}
function P(n, t) {
  return Math.max(Math.min(n, t), 1);
}
function D(n, t, e = 1, o = 5) {
  const a = "...";
  return t === 1 ? [e] : t === 2 ? [e, t] : t <= o ? Array(t).fill(0).map((i, m) => m + 1) : n <= 2 ? [e, e + 1, e + 2, a, t] : n >= t - 1 ? [e, a, t - 2, t - 1, t] : [e, a, n, a, t];
}
function G(n) {
  const { i18n: t = {}, count: e, caption: o } = n, {
    btnNextText: a = "Next page",
    btnPrevText: i = "Previous page",
    btnPageText: m = "Go to page"
  } = t, { page: p, handlePageChange: c, itemList: f, handleKeyDown: b, containerRef: l } = A(n);
  return !e || e === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B, { topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE, bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: d.pagination,
      "data-testid": "pagination",
      onKeyDown: b,
      tabIndex: -1,
      ref: l
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "left",
        "data-testid": "pagination-prev",
        "aria-label": i,
        title: i,
        disabled: p === 1,
        onClick: () => c((r) => r - 1)
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", { className: d.paginationItems, "data-testid": "pagination-items" }, f.map((r, g) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", { key: g }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      R,
      {
        page: r,
        selectedPage: p,
        onSelect: c,
        title: m
      }
    )))),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "right",
        "data-testid": "pagination-next",
        "aria-label": a,
        title: a,
        disabled: p === e,
        onClick: () => c((r) => r + 1)
      }
    )
  ), o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: d.paginationCaption,
      "data-testid": "pagination-caption"
    },
    o
  )));
}
function R({
  page: n,
  selectedPage: t,
  onSelect: e,
  title: o
}) {
  const a = typeof n == "number", i = a && n === t;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      "data-testid": "pagination-item-" + n,
      "aria-current": i ? "page" : void 0,
      "aria-label": a ? `${o} ${n}` : void 0,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__.c)(
        d.paginationItem,
        i && d.paginationItemSelected
      ),
      disabled: !a,
      onClick: () => a && e?.(n),
      title: a ? `${o} ${n}` : void 0
    },
    n
  );
}

//# sourceMappingURL=Pagination.js.map


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 7759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3355);




const b = "chips", k = "chips--compact", E = "chips--bolder", I = "close-icon", o = {
  chips: b,
  chipsCompact: k,
  chipsBolder: E,
  closeIcon: I
}, i = 40;
function _(e) {
  const {
    text: c = "",
    variant: l = "standard",
    bolder: r = !1,
    clipLongText: h = !0,
    selected: s,
    showXWhenSelected: m = !1
  } = e, p = c.length > i, n = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, p && h ? `${c.slice(0, i).trim()}...` : c, m && s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.I, { icon: _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_1__.W.CLOSE, className: o.closeIcon })), a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    e.className,
    r ? o.chipsBolder : _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsBodyText,
    o.chips,
    l === "compact" && o.chipsCompact
  );
  return e.as === "button" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      className: a,
      onClick: e.onClick,
      "aria-checked": !!s,
      role: "checkbox",
      title: c
    },
    n
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      title: c,
      href: e.href || "#",
      disableLinkTextStyle: !0,
      "aria-checked": !!s,
      role: "checkbox",
      className: a
    },
    n
  );
}

//# sourceMappingURL=Chips-2709174d.mjs.map


/***/ })

}]);